<script setup>
import {useAttrs} from "vue";
import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";

defineProps({
  validationErrors: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  label: {
    type: [String, null],
    required: false,
    default: null,
  },
  subtext: {
    type: [String, null],
    required: false,
    default: null,
  },
  containerAttrs: {
    type: Object,
    required: false,
    default: undefined,
  }
});

defineOptions({
  inheritAttrs: false
})

const attrs = useAttrs();

const inputValue = defineModel({
  type: [String],
  required: true,
});
</script>

<template>
  <div class="tw-relative tw-w-full">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
      <label
        v-if="label"
        :for="$attrs.id"
        class="tw-text-font-neutral-900 tw-font-bold tw-text-base"
      >
        {{ label }}
      </label>
      <small
        v-if="subtext"
        class="tw-text-sm"
      >
        {{ subtext }}
      </small>
      <SelectInput
        v-model="inputValue"
        v-bind="attrs"
        :container-attrs="containerAttrs"
        :class="[
          '!tw-px-6 tw-h-9',
          {
            '!tw-border-danger': validationErrors.length > 0,
          }
        ]"
      >
        <slot name="default" />
      </SelectInput>
      <small
        v-for="(error, index) in validationErrors"
        :key="index"
        class="tw-text-danger tw-self-baseline tw-absolute tw-block tw-mt-1"
      >
        {{ error }}
      </small>
    </div>
  </div>
</template>
